import React, { useCallback, useContext, useState } from 'react'
import CartCtx from '../CartCtx'
import { Button, Form, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import axios from 'axios'
import { isIterableArray } from '../block-slider/utils'

const ModalWishlist = (props) => {

    const {
        noWL,
        productId,
        productCount
    } = props

    const state = useContext(CartCtx)
    const {
        lists,
        setLists,
        waitingLists,
        addToWaitList,
        fetchWL
    } = state

    const productIsInThisParticularList = useCallback(
        (listId, productId) => {
            if (!isIterableArray(lists)) return false
            let k = 0
            lists.map((list, index) => {
                let arr = []
                if (list.products && list.products.length > 0) {
                    arr = list.products.filter(product => {
                        return list.id === listId && product.id === productId
                    })
                }
                if (arr.length > 0) return k++
                else return null
            })
            return k > 0
        },
        [lists],
    )

    const productIsInAnyList = useCallback(
        (productId) => {
            if (!isIterableArray(lists)) return false
            let k = 0
            lists.map((list, index) => {
                let arr = []
                if (list.products && list.products.length > 0) {
                    arr = list.products.filter(product => {
                        return product.id === productId
                    })
                }
                if (arr.length > 0) return k++
                else return null
            })
            return k > 0
        },
        [lists]
    )


    // const productIsInWaitingList = useCallback(
    //     (productId) => {
    //         if (!isIterableArray(waitingLists)) return false
    //         return waitingLists?.filter((f, i) => {
    //             return f.id == productId
    //         })?.length > 0
    //     },
    //     [waitingLists]
    // )

    const [inLists, setInLists] = useState([])
    const [inAnyList, setInAnyList] = useState(false)

    const [showM, setShowM] = useState(false)
    const [showN, setShowN] = useState(false)
    const [showHuy, setShowHuy] = useState(false)
    const [newWL, setNewWL] = useState('')
    const [selectedList, setSelectedList] = useState('')

    const changeList = (e) => {
        setSelectedList(e.target.value)
    }
    const handleShow = () => {
        setShowM(true)
        // this.fetchWL()
    }
    const handleClose = () => {
        setShowM(false)
        setShowHuy(false)
    }
    const handleNewShow = () => {
        setShowN(true)
    }
    const handleNewClose = () => {
        setShowN(false)
    }
    const newWishList = (e) => {
        setNewWL(e.target.value)
    }
    const addWishList = () => {
        setShowN(false)
        axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/wish-list/add-list`, {
            jwt: localStorage.getItem('galaxy-token'),
            name: newWL || 'Список ' + (lists.length + 1),
            default: lists.length === 0 ? 1 : 0
        }).then(response => {
            axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/wish-list`, {
                jwt: localStorage.getItem('galaxy-token')
            }).then(response => {
                if (isIterableArray(response?.data?.data)) {
                    setLists(response.data.data)
                }
                else {
                    setLists([])
                }
                setNewWL('')
            })
        })
    }
    const addProductWishList = () => {
        axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/wish-list/add-product-to-list`, {
            jwt: localStorage.getItem('galaxy-token'),
            listId: selectedList,
            productId: productId
        }).then(response => {
            fetchWL()
            setShowM(false)
            setInAnyList(true)
            if (inLists.indexOf(selectedList) === -1) {
                let tmp = []
                tmp.push(selectedList)
                setInLists(tmp)
            }
        }).catch(err => {
            console.error(err)
        })
    }
    
    return (

        <>
            {/* кнопка сердце */}
            {!noWL && Array.isArray(lists) &&
                <div>
                    {
                        (productIsInAnyList(productId) || inAnyList) ?
                            <Button variant="simple"
                                className={`btn-wishlist active act2`}
                                onClick={handleShow}
                                title="В списке желаемого"
                            >
                                <svg className="w20 i-wishlist"><use xlinkHref="#i_like2" /></svg>
                                <span>В избранном</span>
                            </Button>
                            :
                            <Button variant="simple"
                                className={`btn-wishlist`}
                                onClick={handleShow}
                                title="Добавить в список желаемого"
                            >
                                <svg className="w20 i-wishlist"><use xlinkHref="#i_like" /></svg>
                                <span>В избранное</span>
                            </Button>
                    }


                </div>
            }
            {/* кнопка в список ожидания */}
            {/* {productCount === 0 && Array.isArray(waitingLists) &&
                <Button variant="simple"
                    className="waiting"
                    onClick={() => { addToWaitList(productId) }}
                    title={
                        productIsInWaitingList(productId)
                            ?
                            "Уже в списке ожидания"
                            :
                            "Добавить в список ожидания"
                    }
                    disabled={productIsInWaitingList(productId)}
                >
                    <svg className="w20"><use xlinkHref="#i_time" /></svg>
                </Button>
            } */}

            {/* сердце - модалка-заглушка если нет токена */}
            {!localStorage.getItem('galaxy-token') &&
                <Modal
                    show={showM}
                    onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName="modal-sm"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Добавить в список</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="center-block">
                            <p>Чтобы сохранить товар, Вам необходимо  <a href='!' onClick={(e) => {
                                e.preventDefault()
                                handleClose()
                                document.querySelector('.h-profile>button').click()
                            }}>авторизироваться</a>
                            </p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="link" onClick={handleClose} className="btn-secondary">Закрыть</Button>
                        {/*<Link to="/checkout" className="btn btn-primary" onClick={handleClose}>Авторизироваться</Link>*/}
                    </Modal.Footer>
                </Modal>
            }

            {/* список ожидания - модалка-заглушка если нет токена */}
            {!localStorage.getItem('galaxy-token') &&
                <Modal
                    show={showHuy}
                    onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName="modal-sm"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Добавить в список ожидания</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="center-block">
                            <p>Чтобы сохранить товар, Вам необходимо  <a href='!' onClick={(e) => {
                                e.preventDefault()
                                handleClose()
                                document.querySelector('.h-profile>button').click()
                            }}>авторизироваться</a>
                            </p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="link" onClick={handleClose} className="btn-secondary">Закрыть</Button>
                        {/*<Link to="/checkout" className="btn btn-primary" onClick={handleClose}>Авторизироваться</Link>*/}
                    </Modal.Footer>
                </Modal>
            }

            {/* модалка сердце */}
            {localStorage.getItem('galaxy-token') &&
                <Modal
                    show={showM}
                    onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName="modal-sm"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Добавить в список</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mwlist">
                            <div className="mwlist__toolbar">
                                <Button variant="link" className="wlnew__btn" onClick={handleNewShow}>
                                    <span>Создать список</span>
                                </Button>
                                {/* Клик по кнопке добавляет нижнему блоку класс show для отображения */}
                                <div className={`wlnew ${showN ? 'show' : ''}`}>
                                    <Form.Group>
                                        <div className="form-field">
                                            <div className="input-field">
                                                <Form.Control type="text" placeholder="Введите название" onChange={newWishList} />
                                            </div>
                                            <Button variant="simple" onClick={addWishList}>
                                                OK
                                            </Button>
                                            <Button variant="simple" className="btn_cancel" onClick={handleNewClose}>
                                                <svg className="w20">
                                                    <use xlinkHref="#i_plus" />
                                                </svg>
                                            </Button>
                                        </div>
                                    </Form.Group>
                                </div>
                                <Link to="/profile/wishlist" target='_blank' className="">Мои списки</Link>
                            </div>
                            <div className="mwlist__inner">
                                <div className="checkbox-wrap d-flex flex-column">
                                    {
                                        isIterableArray(lists) &&
                                        lists.map((list, i) => {
                                            return (
                                                <div className="checkbox-wrap__item" key={i}>
                                                    <input className="custom-checkbox"
                                                        type="radio"
                                                        name="wl"
                                                        id={`wl-${i}`}
                                                        value={list.id}
                                                        onChange={changeList}
                                                        disabled={productIsInThisParticularList(list.id, productId) || (inLists.length > 0 && inLists.filter(il => il == list.id).length > 0)}
                                                    />
                                                    <label htmlFor={`wl-${i}`}>
                                                        {list.name}
                                                        &nbsp;
                                                        {
                                                            (productIsInThisParticularList(list.id, productId) || (inLists.length > 0 && inLists.filter(il => il == list.id).length > 0))
                                                            &&
                                                            <em>(Товар уже в этом списке)</em>
                                                        }
                                                    </label>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="link" onClick={handleClose} className="btn-secondary">Назад</Button>
                        <Button className="btn btn-primary" onClick={addProductWishList} disabled={selectedList === ''}>Добавить</Button>
                    </Modal.Footer>
                </Modal>
            }

        </>
    )
}

export default ModalWishlist